import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { getMsSinceNativeCallReturn } from "../calls/nativeCallReturnContext";

const ROOT_PATHS = new Set([
  "/",
  "/home",
  "/messages",
  "/my-profile",
  "/settings",
]);

function normalizePath(pathname) {
  if (!pathname) return "/";
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export default function AndroidBackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);

  locationRef.current = location;

  useEffect(() => {
    if (Capacitor.getPlatform() !== "android") {
      return undefined;
    }

    let listener = null;
    let cancelled = false;

    const register = async () => {
      listener = await CapacitorApp.addListener("backButton", () => {
        const path = normalizePath(locationRef.current.pathname);

        if (ROOT_PATHS.has(path)) {
          const msSinceNativeCallReturn = getMsSinceNativeCallReturn();
          console.log(
            `[callReturn] root_back_exit path=${path} msSinceNativeCallReturn=${
              msSinceNativeCallReturn == null ? "n/a" : msSinceNativeCallReturn
            }`
          );
          void CapacitorApp.exitApp();
          return;
        }

        navigate(-1);
      });

      if (cancelled) {
        await listener.remove();
      }
    };

    void register();

    return () => {
      cancelled = true;
      void listener?.remove();
    };
  }, [navigate]);

  return null;
}
